import React from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Checkbox,
  FormControlLabel,
  FormGroup,
  InputAdornment,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

export interface CheckboxListProps {
  id: string;
  label: string;
}

interface CheckBoxListProps {
  items: {
    id: string;
    label: string;
    count?: number | undefined;
  }[];
  selectedItems: string[];
  title: string;
  titleCount: number;
  searchValue: string[];
  index: number;
  onChangeSearch: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onChangeCheckbox: (itemId: string) => void;
}

const FilterComponent = ({
  items,
  selectedItems,
  title,
  titleCount,
  searchValue,
  index,
  onChangeSearch,
  onChangeCheckbox,
}: CheckBoxListProps) => {
  return (
    <Box>
      <Accordion sx={{ boxShadow: 'none' }} defaultExpanded={ true }>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          { titleCount ? (
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              sx={{ width: "100%", paddingRight: "12px" }}
            >
              <Typography
                sx={{ fontSize: "14px", fontWeight: "400", color: "#000000" }}
              >
                {title}
              </Typography>
              <Typography
                sx={{ fontSize: "14px", fontWeight: "400", color: "#6C717A" }}
              >
                {titleCount}
              </Typography>
            </Stack>
          ) : (
            <Typography
              sx={{ fontSize: "14px", fontWeight: "400", color: "#000000" }}
            >
              {title}
            </Typography>
          ) }
        </AccordionSummary>
        <AccordionDetails>
          <Box>
            <TextField
              value={ searchValue?.[index] }
              onChange={ onChangeSearch }
              InputProps={{
                style: {
                  height: '40px',
                  padding: '0px 12px',
                  border: "1px solid #A1A5AB",
                  borderRadius: "4px",
                },
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon sx={{ color: "#000000", fontSize: "20px" }} />
                  </InputAdornment>
                ),
              }}
              placeholder="Search"
              sx={{ marginBottom: '12px', width: '100%', height: '40px', }}
              variant="outlined"
            />
            <FormGroup>
              { items?.length > 0 ? (
                <>
                  {items?.map((item) => {
                    return (
                      <Box
                        key={item.id}
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <FormControlLabel
                          key={item.id}
                          control={
                            <Checkbox
                              checked={selectedItems?.includes(item?.id)}
                              onChange={() => onChangeCheckbox(item?.id)}
                            />
                          }
                          label={item?.label === 'false' ? 'Not Claimed' : item?.label === 'true' ? 'Claimed' : item?.label}
                        />
                        { item?.count && (
                          <Typography
                            sx={{
                              fontSize: "14px",
                              fontWeight: "400",
                              color: "#6C717A",
                            }}
                          >
                            {item?.count}
                          </Typography>
                        ) }
                      </Box>
                    )
                  })}
                </>
              ) : (
                <Typography
                  sx={{
                    fontSize: "14px",
                    fontWeight: "400",
                    color: "#6C717A",
                  }}
                >
                  No Item found
                </Typography>
              ) }
            </FormGroup>
          </Box>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
};

export default FilterComponent;
